import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  ADVANCEFEES,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchAdvanceFee = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_ADVANCE_FEES}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_ADVANCE_FEES}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_ADVANCE_FEES}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_ADVANCE_FEES}${query}${sorting}`);
};

const fetchAddedItemsList = async ({ gid, params }) => axiosAuthInstance.patch(`${API_END_POINTS.GET_ADVANCE_FEES}/${gid}/items`, params);

const getAdvanceFeesById = async gid => axiosAuthInstance.get(`${API_END_POINTS.GET_ADVANCE_FEES}/${gid}`);

const postAdvanceFee = async payload => axiosAuthInstance.post(API_END_POINTS.GET_ADVANCE_FEES, payload);

const patchAdvanceFee = async payload => axiosAuthInstance.patch(`${API_END_POINTS.GET_ADVANCE_FEES}/${payload.gid}`, payload.params);

const deleteSelectedAdvanceFee = async gid => axiosAuthInstance.delete(`${API_END_POINTS.GET_ADVANCE_FEES}/${gid}`);

export function* getAdvanceFees(action) {
  try {
    const { data: { entity } } = yield call(fetchAdvanceFee, action.payload);
    yield put({ type: ADVANCEFEES.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ADVANCEFEES.FAILED, payload: e.response.data });
  }
}

export function* addAdvanceFee(action) {
  try {
    yield put({ type: LOADING.SET });
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postAdvanceFee, action.payload);
    const { data: { entity } } = yield call(fetchAdvanceFee, action.payload);
    yield put({ type: ADVANCEFEES.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.ADVANCEFEES.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
    yield put({ type: LOADING.UNSET });
  }
}

export function* updateAdvanceFee(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchAdvanceFee, action.payload);
    const { data: { entity } } = yield call(fetchAdvanceFee, action.payload);
    yield put({ type: ADVANCEFEES.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.ADVANCEFEES.UPDATE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* deleteAdvanceFee(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(deleteSelectedAdvanceFee, action.payload.gid);
    const { data: { entity } } = yield call(fetchAdvanceFee, action.payload);
    yield put({ type: ADVANCEFEES.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.ADVANCEFEES.DELETE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* fetchAdvanceFeeById(action) {
  try {
    const { data: { entity } } = yield call(getAdvanceFeesById, action.payload);
    yield put({ type: ADVANCEFEES.SUCCESS_BY_ID, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ADVANCEFEES.FAILED, payload: e.response.data });
  }
}

export function* getAdvanceFeeItems(action) {
  try {
    const { data: { entity } } = yield call(fetchAddedItemsList, action.payload);
    yield put({ type: ADVANCEFEES.SUCCESS_ADD_ITEMS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: ADVANCEFEES.FAILED, payload: e.response.data });
  }
}
